// extracted by mini-css-extract-plugin
export default {"header":"Header_header__P3zKJ","header__title":"Header_header__title__5YYAa"};